export default {
  title: "Benefit groups",
  new: "New Group",
  edit: "Edit group",
  list: "Group list",
  legislated_benefits: "Legislated benefits",
  flexible_benefits: "Flexible benefits",
  custom_benefits: "Custom benefits",
  benefits: "benefits",
  benefit_type_legislated: "legislated",
  benefit_type_flexible: "not legislated",
  no_benefits_available: "You have no {type} benefits allocated",
  legislated_non_legislated: "Legislated/Non-legislated",
  detail: {
    ben_name: 'Benefit name',
    contribution: {
      client: 'Employer contribution',
      personal: 'Personal contribution'
    },
    partner_name: 'Partner',
    description: 'Description',
    allocation_control: 'Allocation control',
    allocated: 'Allocated',
    not_allocated: 'Not Allocated',
    cash_out_schedule_title: 'Cash Out schedule',
    cash_out_schedule_hint: 'Optional. If set, Cash Out is available only between the start and end of the selected days.',
    cash_out_schedule_disabled_hint: 'Allocate Cash Out first to set its availability period.',
    cash_out_start_date: 'Start date',
    cash_out_end_date: 'End date',
    cash_out_schedule_reset: 'Reset',
  },
  modal: {
    confirm_save: 'Are you sure you want to save the changes?',
    confirm_leave: 'The information has been changed, are you sure you want to leave?',
    confirm_delete: 'Are you sure you want to delete the group?',
    disclaimer_delete: 'Beneficiaries that have this group allocated will be allocated the default group. '
  },
  types: {
    all: 'All',
    default: 'Default',
    not_default: 'Custom',
  },
  benefit_types: {
    all: 'All',
    1: 'Flexible Benefits',
    2: 'Fixed Benefits',
  },
  fields: {
    title: "Benefit groups",
    company: "Client",
    group: "Group",
    code: "Group Code",
    benefits: 'Benefits',
    type: 'Group type',
    benefit_type: "Benefit types",
  },
  btn: {
    add_all: 'Select all',
    add_all_ro: 'Select all Ro',
    add_all_int: 'Select all INT',
    remove_all_int: 'Deselect all INT',
    remove_all: 'Deselect all',
  }
}
